import { isNull } from 'lodash';
import { IDS } from '../pnp-settings-document-category.constants';
import * as PnpDocumentCategoryActions from '../pnp-settings-document-category.actions';
import * as PnpSettingsActions from '../../pnp-settings.actions'

/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpSettingsDocumentCategoryDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $scope, $rootScope, FileActions, Notifier,AuthService ) {
        const unsubscribe = $ngRedux.connect(({ policies }) => ({
            pnpSettingsDocumentCategory: policies.pnpSettingsDocumentCategory
        }), {
            ...FileActions,
            ...PnpDocumentCategoryActions,
            ...PnpSettingsActions,
        })(this);
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            // Fetch default categories on initialization
            this.getSettingsDefaultCategories();

            const operation = this.pnpSettingsDocumentCategory.id ? 'Update' : 'Add';
            this.title = `${operation} Document Category`;
            this.admin = AuthService.getUser().typeCode === 'adm';
            this.stateIdentifier = 'pnpSettingsDocumentCategory';
            if (this.pnpSettingsDocumentCategory.id) {
                this.identifier = IDS.app_policies_settings_categories_manage;
                this.state = IDS.app_policies_settings_categories_manage_details;
            }
            else {
                this.identifier = IDS.app_policies_settings_categories_add;
                this.state = IDS.app_policies_settings_categories_add_details;
            }
        }

        this.saveDetails = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.pnpSettingsDocumentCategoryForm');
            if (!this.pnpSettingsDocumentCategory || !this.pnpSettingsDocumentCategory.name) {
                Notifier.error('Please fill in the form fields');
            } else if(this.pnpSettingsDocumentCategory.name.label){
                    this.saveDocumentCategory(this.pnpSettingsDocumentCategory, this.Notifier).then(() => {
                        this.pnpSettingsDocumentCategory.id
                            ? Notifier.success('Document category has been successfully updated.')
                            : Notifier.success('Document category has been successfully created.');
                        if (isNull(this.pnpSettingsDocumentCategory.id)) {
                            this.resetForm();
                        }
                    }).catch((error) => {
                        if (error.data && error.data.status === 10) {
                            Notifier.error('This document category already exists. Please choose a different name.');
                        } else {
                            Notifier.error('System Error!');
                        }
                    });
            }
        }

        this.handleFreeText = (event) => {
            if (event.target.value && !this.pnpSettingsDocumentCategory.defaultCategory) {
                this.pnpSettingsDocumentCategory.defaultCategory = { label: event.target.value };
            }
        };

        this.resetForm = () => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', '$ctrl.pnpSettingsDocumentCategoryForm');
            this.pnpSettingsDocumentCategoryForm.$setPristine();
            this.pnpSettingsDocumentCategoryForm.$setUntouched();
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
        }

    },
    template: require('./pnp-document-category-details.html')
}
